export const CMS_PAGE_PREFIX = '/magnoliapublic/.rest/jetblue/v4/page/';
export const STATIC_PAGE_PREFIX = '/ui-assets/text-content/';
